module.exports = __webpack_public_path__ + "static/media/moment-row-star.e52df6ee.svg";